import { render } from "./CertificateSheet.vue?vue&type=template&id=5490089b&scoped=true"
import script from "./CertificateSheet.vue?vue&type=script&lang=js"
export * from "./CertificateSheet.vue?vue&type=script&lang=js"

import "./CertificateSheet.vue?vue&type=style&index=0&id=5490089b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5490089b"]])

export default __exports__